export default class AuthLoginResponse {
  public challenge: string;
  public secret: string;
  public smsProtect: string;
  public userId: string;

  constructor(options) {
    this.challenge = options.challenge;
    this.secret = options.secret;
    this.smsProtect = options.smsProtect;
    this.userId = options.userId;
  }
}
